import React from 'react';
import { db } from "firebase/fbConfig.js"
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import styles from "assets/jss/material-dashboard-pro-react/components/ActionSubmitFormStyle.jsx";
import withStyles from "@material-ui/core/styles/withStyles";

import moment from 'moment';

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import DatePicker from 'react-date-picker';

import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import Button from "components/CustomButtons/Button.jsx";
import Typography from "@material-ui/core/Typography"

import Card from '@material-ui/core/Card';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import PrototypeExploreAssignUser from "../../views/Explore/PrototypeExploreAssignUser";

const INITIAL_STATE = {
    business: null,
    dollarAmount: 0,
    type: '',
    description: '',
    category: ''
}

class EntryForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = INITIAL_STATE
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.isModal && this.props.registry) {
            const { id, ...registry } = this.props.registry;
            id !== this.state.id && this.setState(this.props.registry);
        }
    }


    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value,
        })
    }

    handleDollarAmountChange = (e) => {
        if (e.target.value.includes('.')) {
            if (e.target.value.split('.')[1].length > 2) {
                return;
            } else {
                this.setState({
                    [e.target.id]: e.target.value,
                })
            }
        } else {
            this.setState({
                [e.target.id]: e.target.value,
            })
        }
    }

    handleCheckACHChange = (e) => {
        this.setState({
            checkACHNumber: e.target.value
        })
    }

    handleDateChange = date => {
        this.setState({
          date: date
        });
      };

      handleReceivedDateChange = receivedDate => {
        this.setState({
          receivedDate: receivedDate
        });
      };

    handleSelectChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    sendEntry = () => {
        const dollarAmount = parseFloat(this.state.dollarAmount);
        if ((dollarAmount || dollarAmount === 0)  && this.state.type ) {
            db.collection('haney-orders').doc(this.props.orderID).collection(this.props.isActual ? 'paymentsRegister' : 'register').add({
                dollarAmount: dollarAmount,
                type: this.state.type,
                date: this.state.date ? this.state.date : "",
                receivedDate: this.state.receivedDate ? this.state.receivedDate : "",
                checkACHNumber: this.state.checkACHNumber ? this.state.checkACHNumber : "",
                description: this.state.description,
                category: this.state.category,
                business: this.state.business
            }).then(res => {
                this.setState(INITIAL_STATE);
            })
        }
    }

    saveEntry = async () => {
        const dollarAmount = parseFloat(this.state.dollarAmount);
        const { id, ...registry } = this.state;
        if ((dollarAmount || dollarAmount === 0) && this.state.type) {
            await db.collection('haney-orders').doc(this.props.orderID).collection(this.props.isActual ? 'paymentsRegister' : 'register').doc(id).set({
                dollarAmount: dollarAmount,
                type: this.state.type,
                date: this.state.date ? this.state.date : "",
                receivedDate: this.state.receivedDate ? this.state.receivedDate : "",
                checkACHNumber: this.state.checkACHNumber ? this.state.checkACHNumber : "",
                description: this.state.description,
                category: this.state.category,
                business: this.state.business
            }, { merge: true })
            this.props.closeModal()
        }
    }


    assignBusiness = (doc, arr, query) => {
        console.log(doc);
        let business = {};
        business['businessName'] = doc.name;
        business['id'] = doc.id;

        this.setState({
            business: business,
            [query]: ''
        })
    }


    render() {
        const classes = this.props.classes;
        const categories = ['Revenue', 'Expense', 'Customer Discount', 'Vendor Credit'];
        const actualCategories = ['Revenue', 'Expense'];
        const types = ['quote approved', 'Additional Stop', 'Attempt Charge', 'Wait Time', 'Lumper Fee', 'Limited Access Delivery Fee', 'Reweigh', 'Re-class', 'Miscellaneous'];
        const actualTypes = ['AR - Full Payment', 'AR - Partial Payment', 'AP - Full Payment', 'AP - Partial Payment'];
        console.log(this.state)

        return (
            <Grid container xs={12} spacing={3} className={this.props.classes.addItemModal} >
                <Grid item xs={12}>
                    <Typography variant="h4" style={{ textAlign: "center" }}>
                        Add Item
                    </Typography>
                </Grid>
                <Grid item xs={12} >
                    <PrototypeExploreAssignUser
                        labelText={"Search Business Name"}
                        collection={"haney-vendors"}
                        collection2={"haney-shippers"}
                        id={"businessQuery"}
                        onChange={this.handleChange}
                        value={this.state.businessQuery ? this.state.businessQuery : ''}
                        assignUser={this.assignBusiness}
                    //   stateObj={arrString}
                    />

                </Grid>
                <Grid item xs={12}>
                    <b>{this.state.business && this.state.business.businessName}</b>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        label="Dollar Amount"
                        id="dollarAmount"
                        fullWidth
                        required={true}
                        type="number"
                        onChange={(event) => this.handleDollarAmountChange(event)}
                        value={this.state.dollarAmount}
                    />
                </Grid>
                {this.props.isActual &&
                <Grid item xs={12}>
                <TextField
                    label="Check/ACH Number"
                    id="checkACHNumber"
                    fullWidth
                    required={true}
                    type="text"
                    onChange={(event) => this.handleCheckACHChange(event)}
                    value={this.state.checkACHNumber}
                />
            </Grid>
                }
                {this.props.isActual && <Grid item xs={12}>
                Deposit/Pay Date
                 <DatePicker
                    onChange={this.handleDateChange}
                    value={this.state.date ? (this.state.date.seconds ? this.state.date.toDate() : this.state.date) : ''}
                  />
                </Grid>}
                {this.props.isActual && <Grid item xs={12}>
                Invoice/Payment Received Date
                 <DatePicker
                    onChange={this.handleReceivedDateChange}
                    value={this.state.receivedDate ? (this.state.receivedDate.seconds ? this.state.receivedDate.toDate() : this.state.receivedDate) : ''}
                  />
                </Grid>}
                <Grid item xs={6}>
                    <FormControl
                        fullWidth
                        className={classes.selectFormControl}>
                        <InputLabel
                            htmlFor="category"
                            className={classes.selectLabel}>
                            Entry Category:
                        </InputLabel>
                        <Select
                            MenuProps={{
                                className: classes.selectMenu
                            }}
                            classes={{
                                select: classes.select
                            }}
                            value={this.state.category}
                            onChange={this.handleSelectChange}
                            inputProps={{
                                id: 'category',
                                name: 'category'
                            }}
                            fullWidth
                        >
                            {
                                (this.props.isActual ? actualCategories : categories).map((category) => (
                                    <MenuItem
                                        classes={{
                                            root: classes.selectMenuItem
                                        }}
                                        value={category.toLowerCase()}
                                        key={category}
                                    >{category}</MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={6}>
                    <FormControl
                        fullWidth
                        className={classes.selectFormControl}>
                        <InputLabel
                            htmlFor="terms"
                            className={classes.selectLabel}>
                            Type:
                        </InputLabel>
                        <Select
                            MenuProps={{
                                className: classes.selectMenu
                            }}
                            classes={{
                                select: classes.select
                            }}
                            value={this.state.type}
                            onChange={this.handleSelectChange}
                            inputProps={{
                                id: 'type',
                                name: 'type'
                            }}
                            fullWidth
                        >
                            {
                                (this.props.isActual ? actualTypes: types).map((type) => (
                                    <MenuItem
                                        classes={{
                                            root: classes.selectMenuItem
                                        }}
                                        value={type.toLowerCase()}
                                        key={type}
                                    >{type}</MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <TextField

                        label="Freeform Description"
                        id="description"
                        fullWidth
                        required={true}
                        type="text"
                        onChange={(event) => this.handleChange(event)}
                        value={this.state.description}

                    />
                </Grid>
                <Grid item>
                    <Button
                        color="primary"
                        onClick={() => this.props.isModal ? this.saveEntry() : this.sendEntry()}
                    >
                        {this.props.isModal ? 'SAVE' : 'SUBMIT'}
                    </Button>

                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        AuthBool: !!state.auth.user,
        authUser: state.auth.user,
        user: state.profile.user,
    }
}

export default compose(
    connect(mapStateToProps),
    withStyles(styles)
)(EntryForm);


// WEBPACK FOOTER //
// ./src/components/Forms/CreateEntryForm.jsx